import { trigger, state, style, animate, transition } from '@angular/animations';

export const smoothDropingDown = [
  trigger('dropdownTrigger', [
    transition(':enter', [
      style({ transform: 'translateY(-10%)', opacity: 0 }),
      animate('200ms', style({ transform: 'translateY(0)', opacity: 1 })),
    ]),
    transition(':leave', [
      animate('200ms', style({ transform: 'translateY(-10%)', opacity: 0 }))
    ])
  ]),
]

export const fadeInOut = [
  trigger('fadeInOutTrigger', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate('400ms', style({ opacity: 1 })),
    ]),
    transition(':leave', [
      animate('400ms', style({ opacity: 0 }))
    ])
  ]),
]

export const slideInOutAnimation = trigger(
  'slideInOut', [
  transition(':enter', [
    style({ transform: 'translateX(100%)', opacity: 0 }),
    animate('1000ms', style({ transform: 'translateX(0)', opacity: 1 }))
  ]),
  transition(':leave', [
    style({ transform: 'translateX(0)', opacity: 1 }),
    animate('1000ms', style({ transform: 'translateX(100%)', opacity: 0 }))
  ])
]);

